<template>
  <ul
    class="product-tabs"
    ref="productTabs"
  >
    <li
      v-for="item in getTabItems"
      :key="item.route"
    >
      <template v-if="!item.hide">
        <RouterLink
          v-if="item.route"
          :to="routeTo({ name: item.route })"
          @click.native="onClick(item.route)"
          :class="{'active': $route.name === item.route}"
        >
          <span>{{ item.text }}</span>
          <small
            class="text-center"
            v-if="!item.hideCount && item.count > -1"
          >
            {{ item.count }} Ürün
          </small>
        </RouterLink>
      </template>
    </li>
  </ul>
</template>

<script>
import service from '@/services/product';
import filter from '@/storages/filter';
import supplierService from '../../../services/supplier';

export default {
  name: 'ListTabs',
  data () {
    return {
      items: [{
        route: 'ListingAll',
        text: this.$t('list.tab.all'),
        count: -1,
        hideCount: true,
      }, {
        route: 'ListingOnSale',
        text: this.$t('list.tab.onSelling'),
        key: 'onSale',
        count: -1,
        notification: true,
      }, {
        route: 'ListingOutOfStock',
        text: this.$t('list.tab.outOfStock'),
        key: 'outOfStock',
        count: -1,
      }, {
        route: 'ListingRejected',
        text: this.$t('list.tab.rejected'),
        key: 'rejected',
        count: -1,
      }, {
        route: 'ListingNotOnSale',
        text: this.$t('list.tab.notOnSelling'),
        key: 'notOnSale',
        count: -1,
      }, {
        route: 'ListingActionNeeded',
        text: this.$t('list.tab.actionNeeded'),
        key: 'actionNeeded',
        count: -1,
      },
      {
        route: 'ListingArchived',
        text: this.$t('list.tab.archived'),
        key: 'archived',
        count: -1,
      },
      ],
      supplierDetail: {},
    };
  },
  computed: {
    isDraftOrPassiveSupplier () {
      return this.supplierDetail.status === 'PASSIVE' || this.supplierDetail.status === 'DRAFT';
    },
    getTabItems () {
      let allTabItems = this.items;
      if (this.isDraftOrPassiveSupplier) {
        allTabItems = [
          {
            route: 'ListingAll',
            text: this.$t('list.tab.all'),
            count: -1,
            hideCount: true,
          },
        ];
      }
      return allTabItems;
    },
  },
  methods: {
    async getProductsCount () {
      const data = await service.getProductsCount();
      this.getTabItems = this.getTabItems.map(tabItem => {
        const item = tabItem;
        item.count = data[item.key] || 0;

        return item;
      });
    },
    async reset () {
      filter.clear();
      filter.set({
        page: 0,
      });
    },
    routeTo (params) {
      return params;
    },
    onClick (routeName) {
      const events = {
        ListingAll: 'tümürünlersayfasiclick',
        ListingOnSale: 'satistakilersayfasiclick',
        ListingOutOfStock: 'tükenenlersayfasiclick',
        ListingRejected: 'reddedilenlersayfasiclick',
        ListingNotOnSale: 'satistaolmayanlarclick',
        ListingActionNeeded: 'aksiyonbekleyenlerclick',
      };
      this.$root.trackEvent({
        eventCategory: 'MobileAppListing',
        eventAction: 'ürünsayfasıclick',
        eventLabel: events[routeName] || 'tümürünlersayfasiclick',
      });

      this.reset();
      this.$emit('tabChange');
      this.setPosition();
    },
    setPosition () {
      setTimeout(() => {
        const selected = document.querySelector('.product-tabs li a.active');
        const list = document.querySelector('.product-tabs');
        list.scrollTo({
          left: selected.parentElement.offsetLeft - ((list.clientWidth - selected.clientWidth) / 2),
          behavior: 'smooth',
        });
      }, 250);
    },
    async getSupplierDetail () {
      try {
        const { marketPlaceDetail } = await supplierService.getSupplierDetail();
        this.supplierDetail = marketPlaceDetail;
      } catch (error) {}
    },
  },
  async created () {
    this.getProductsCount();
    this.getSupplierDetail();
  },
  mounted () {
    this.setPosition();
  },
};
</script>

<style lang="scss" scoped>
  .product-tabs {
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    overflow-x: auto;
    li {
      display: flex;
      position: relative;
      a {
        position: relative;
        display: block;
        padding: 10px;
        flex: 1;
        white-space: nowrap;
        text-align: center;
        text-decoration: none;
        color: #95A1B5;
        span {
          display: block;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 3px;
        }
        small{
          font-size: 12px;
          display: block;
        }

        &:before {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          border-radius: 1px;
        }
        &.active-exact,
        &.active {
          span{
            color: #f27a1a;
          }
          small {
            color: #273142;
          }

          &:before {
            background-color: #f27a1a;
            z-index: 1;
            border-radius: 1px;
          }
        }
      }

      &:before {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #dcdee4;
      }
      &:first-child{
        padding-left: 10px;
      }
      &:last-child{
        padding-right: 10px;
      }
    }
  }
</style>
